import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import ContentHeading from "../../shared/commonComponents/ContentHeading";
import EventItem from "../../shared/commonComponents/EventItem";
import LeaderBoard from "../../shared/commonComponents/LeaderBoard";
import ConclaveMember from "./ConclaveMember";
import { useSelector } from "react-redux";

import { OnboardingAxios, UserActivityAxios } from "../../API";
import { Spinner } from "react-bootstrap";

const ConclaveTab = () => {
  const [eventsList, setEventsList] = useState([]);
  const [conclaveMemberList, setConclaveMemberList] = useState([]);
  const [leaderboard, setLeaderboard] = useState([]);
  const coachOnlyActivities = useSelector((state) => state.auth.coachOnlyActivities);
  const loggedInUser = useSelector((state) => state.auth.loggedInUser);
  const [dataLoading, setDataLoading] = useState(true);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 1720,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          initialSlide: 5,
        },
      },
      {
        breakpoint: 1680,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          initialSlide: 4,
        },
      },
    ],
  };

  useEffect(() => {
    setEventsList([...coachOnlyActivities]);
    refreshMembers();
    getConclaveLeaderboard();
  }, []);

  const refreshMembers = () => {
    setDataLoading(true);
    OnboardingAxios.get(
      `Conclave/getmyconclaveconnections/${loggedInUser.offeringUserId}`
    )
      .then((res) => {
        setConclaveMemberList([]);
        setDataLoading(false);
        setConclaveMemberList(res.data);
        document.querySelector('.slick-arrow.slick-prev').click();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getConclaveLeaderboard = () => {
    setDataLoading(true);
    UserActivityAxios.get(
      `Leaderboard/getconclaveleaderboard/${loggedInUser.offeringUserId}`
    )
      .then((res) => {
        setDataLoading(false);
        setLeaderboard([]);
        if (res.data.length > 0)
          setLeaderboard(res.data.sort((a, b) => b.points - a.points));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="px-3 py-4 scroll-content">
      <ContentHeading title={"Members of your Conclave"} />
      <div className="content-padding py-4">
        <div className="conclave-member-list">
          <Slider {...settings}>
            {conclaveMemberList.length > 0 ? conclaveMemberList.map((item, index) => {
              return (
                <ConclaveMember key={index} item={item} refreshMembers={refreshMembers} />
              );
            })
              : dataLoading ? <div className="loading-container" ><span className="me-2">Loading </span><Spinner className="m-0" animation="border" variant="primary" size="sm" /></div>
                : <div className="loading-container" >No Members Available </div>
            }
          </Slider>
        </div>
      </div>
      <ContentHeading title={"Huddle with your Conclave"} />
      <div className="content-padding py-4">
        {eventsList && eventsList.length > 0 && eventsList.map((item) => {
          return (
            <EventItem
              item={item}
              key={"event-item" + item.activityId}
              hideAction={true}
            />
          );
        })}
      </div>

      <div className="row">
        <LeaderBoard className="col-6" title="Conclave Leaderboard">
          <div>
            {leaderboard.length > 0 ? leaderboard.map((item, index) => {
              return (
                <>
                  <div key={index} className="corner-border">
                    <div className="teamInfo">
                      <span className="team-rank">{item.currentRank}</span>
                      <div style={{ display: "grid" }}>
                        <span className="team-name">{item.teamName}</span>
                        <span className="team-name">{item.missionName}</span>
                      </div>
                      <div className="team_points">{item.points} Pts</div>
                    </div>
                  </div>
                </>
              );
            })
              : dataLoading ? <div className="loading-container"><span className="me-2">Loading</span><Spinner className="m-0" animation="border" variant="primary" size="sm" /></div>
                : <div className="loading-container" >No Members Available </div>
            }
          </div>
        </LeaderBoard>
      </div>
    </div>
  );
};

export default ConclaveTab;
